module.exports = __webpack_public_path__ + "img/room-design-competition_in.63f887c6.png";